
import fileUpload from '@/components/file-upload'
import selectSupply from '@/components/browse/select-supply';
import selectRelateFlow from '@/components/browse/select-relate-flow';
import DivSpan from '@/components/DivSpan'
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: "leave-message-edit",
components: {
fileUpload,
DivSpan,
selectSupply,
selectRelateFlow,
Popup,
},
data() {
return {
baseDto:{
commenter: {},
department: {},
belongSupplier: null,
supplier: null,
flowState: 'send',
relevantFlow: [],
attachment: {},
},
relevantFlow: [],
personForSupplier: [],
isVisible: false,
userType: 0,
typeList:[[{name:'采购方',code:1}],[{name:'采购方',code:1},{name:'供应商',code:0}]],
}
},
methods: {
formData(){
return this.baseDto
},
valid(){
if(this.baseDto.leaveType){
if(this.baseDto.leaveToName==null){
this.$vux.toast.text('请选择被留言人')
return false;
}
}else{
if(this.baseDto.supplier==null || this.baseDto.supplier.supplierName==null){
this.$vux.toast.text('请选择供应商')
return false;
}
}
if(!this.baseDto.title){
this.$vux.toast.text('请输入标题')
return false;
}
if(!this.baseDto.content){
this.$vux.toast.text('请输入内容')
return false;
}

return true;
},
leaveTypeChange(e){

if(this.userType==0){
if(e==0 ){
this.baseDto.leaveType=1
}else if(e==1){
this.baseDto.supplier=null;
}

}else {

if(e==1){
this.baseDto.supplier=null;
}
}

},
getSupplier(e){
if(e){
this.baseDto.supplier=e;
this.supAccount(e.id);
}
},
supAccount(id) {
this.$get('api/sup-account/get-person-by-supplier-id?supplierId='+id).then(data => {
let result = data;
this.baseDto.leaveTo = this.splitId(result);
this.baseDto.leaveToUser = result;
this.baseDto.leaveToName = '';
});
},
splitId(result) {
let ids = '';
let persons = [];
persons = result;
for (let i = 0; i < persons.length; i++) {
ids += persons[i].id + ',';
}
return ids;
},
splitName(result) {
let names = '';
let persons = [];
persons = result;
for (let i = 0; i < persons.length; i++) {
names += persons[i].name + ' ';
}
return names;
},
getPerson(e){
if(e){
this.baseDto.leaveTo = this.splitId(e);
this.baseDto.leaveToUser = e;
this.$set(this.baseDto,'leaveToName',this.splitName(e))
}
},

selectSupplier(){
this.$refs.supplierRef.showPop();
},

selectPerson(){
this.$refs.personRef.showPop();
},
selectFlow(){
this.$refs.flowRef.showPop();
},
getRelateFlow(e){
if(e && e.length){
this.baseDto.relevantFlow=[];
for(let i=0;i<e.length;i++){
this.baseDto.relevantFlow.push({checked:false,createdBy:e[i].createdBy,createdDate:e[i].createdDate,requestId:e[i].requestId,title:e[i].title,workflowId:e[i].workflowId})
}
}else {
this.baseDto.relevantFlow=[];
}
this.relevantFlow=e;
},
itemView() {
this.isVisible = !this.isVisible;
},
getCurrent(){
this.$loadingShow()
this.$get('api/person/current').then(data=>{
this.userType=data.userType;
this.baseDto.commenter=data;
this.baseDto.department=data.department;
this.baseDto.userName = data.name;
if (data.user.userType == 0) {
this.baseDto.leaveType = 1;
this.$get('api/supplier/current-sample').then(data => {
this.baseDto.belongSupplier = data;
let arr = data.personList;
arr.forEach(person => this.personForSupplier.push(person.id));
this.$loadingHide()
}).catch(err=>{this.$loadingHide()})
} else {
this.$loadingHide()
}
})
},


},
mounted() {
this.getCurrent();
}

}



// WEBPACK FOOTER //
// ./src/page/leave-message/leave-message-edit.vue